import { OffersPromoRepository } from "../Repository/OffersPromoRepository";
import { Banner } from "../Model/Banner";

export interface UpdateTableBannerUseCase {
    invoke: (data: Banner) => Promise<boolean>;
  }
  
  export class UpdateTableBanner implements UpdateTableBannerUseCase {
    private Repo: OffersPromoRepository;
    constructor(_Repo: OffersPromoRepository) {
      this.Repo = _Repo;
    }
  
    async invoke(data: Banner){
       
        if(!data){
            throw new Error(
                "Your todo should have at leat 2 characters."
              );
        }
         
        const update  = await this.Repo.updateTableBanner(data);
        return update;
    }
  }